// extracted by mini-css-extract-plugin
export var label = "WordpressMenu-module--label--8c068";
export var menu = "WordpressMenu-module--menu--d4f21";